import { render, staticRenderFns } from "./IconAlert.vue?vue&type=template&id=76f641e8&scoped=true&lang=pug"
import script from "./IconAlert.vue?vue&type=script&lang=ts"
export * from "./IconAlert.vue?vue&type=script&lang=ts"
import style0 from "./IconAlert.vue?vue&type=style&index=0&id=76f641e8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f641e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76f641e8')) {
      api.createRecord('76f641e8', component.options)
    } else {
      api.reload('76f641e8', component.options)
    }
    module.hot.accept("./IconAlert.vue?vue&type=template&id=76f641e8&scoped=true&lang=pug", function () {
      api.rerender('76f641e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Alert/CustomAlert/IconAlert.vue"
export default component.exports